import { alpha, styled } from "@mui/material"

const StyledWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>(({ theme, open }) => ({
  marginTop: theme.spacing(2), // 16px
  border: open
    ? "none"
    : `1px solid ${open ? theme.palette.grey[100] : alpha(theme.palette.common.black, 0.5)}`,
  backgroundColor: open ? "rgba(0, 0, 0, 0)" : theme.palette.common.white,
  borderRadius: open ? "4px" : "9999px",
  [theme.breakpoints.up("md")]: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${open ? theme.palette.grey[100] : alpha(theme.palette.common.black, 0.5)}`,
  },
}))

export default StyledWrapper
